// noinspection JSUnusedGlobalSymbols -- imported via t.ds
class TaskError {
	/**
	 * @param {TaskError.Type} type
	 * @param {TaskError.Error} error
	 */
	constructor(type, error) {
		this.type = type;
		this.error = error;
	}

	getDisplayValueForError() {
		switch (this.error) {
			case "constraint-points-to-parent":
				return 'Constraint points to parent task';
			case "constraint-task-contains-errors":
				return 'Related task contains errors';
			case "subtasks-contains-errors":
				return 'Subtask contains errors';
			case "recursive-constraints":
				return 'Constraints generate a loop'
			case "constraints-cant-be-solved":
				return "Constraints can't be solved"
		}
	}
}

export {TaskError}
